<div class="work-interval">
  <div
    class="interval-item"
    [ngClass]="{
      'interval-item--work-time': status.int_type === 1,
      'interval-item--lunch-time': status.int_type === 2,
      'interval-item--expiration-time': status.int_type === 3,
      'interval-item--intermediate': status.isIntermediate
    }"
    *ngFor="let status of statuses"
    [ngStyle]="status.style"
  ></div>
</div>

